import { createAsyncThunk } from '@reduxjs/toolkit';
import { setGlobalLoading } from '../../../redux/slice';
import * as api from '../api';

export const doCheckMissingDriverIds = createAsyncThunk('drivers/doCheckMissingDriverIds', async (_, thunkAPI) => {
  try {
    const { response, error } = await api.checkMissingDriverIds();
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doSeedDriverIds = createAsyncThunk('drivers/doSeedDriverIds', async (_, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.seedDriverIds();
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetDrivers = createAsyncThunk('drivers/doGetDrivers', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.getDrivers(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetDriver = createAsyncThunk('drivers/doGetDriver', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.getDriver(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateDriver = createAsyncThunk('drivers/doCreateDriver', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.createDriver(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateDriver = createAsyncThunk('drivers/doUpdateDriver', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const id = params.id;
    delete params.id;
    const { response, error } = await api.updateDriver(params, id);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doApproveDriver = createAsyncThunk('drivers/doApproveDriver', async (payload, thunkAPI) => {
  try {
    const id = typeof payload === 'object' ? payload.id : payload;
    const email = typeof payload === 'object' ? payload.email : undefined;
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.approveDriver(id, email);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doRejectDriver = createAsyncThunk('drivers/doRejectDriver', async (payload, thunkAPI) => {
  try {
    const id = typeof payload === 'object' ? payload.id : payload;
    const email = typeof payload === 'object' ? payload.email : undefined;
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.rejectDriver(id, email);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doLockDriver = createAsyncThunk('drivers/doLockDriver', async (id, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.lockDriver(id);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doBroadcastDriversNotification = createAsyncThunk(
  'drivers/doBroadcastDriversNotification',
  async (params, thunkAPI) => {
    try {
      thunkAPI.dispatch(setGlobalLoading(true));
      const { response, error } = await api.broadcastDriversNotification(params);
      thunkAPI.dispatch(setGlobalLoading(false));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
//   try {
//     thunkAPI.dispatch(setGlobalLoading(true));
//     const id = params.id;
//     const { response, error } = await api.removeClient(id);
//     thunkAPI.dispatch(setGlobalLoading(false));
//     return error ? thunkAPI.rejectWithValue(error) : response;
//   } catch (e) {
//     thunkAPI.rejectWithValue(e);
//     throw e;
//   }
// });
